export const GLOBAL_STATE = 'Payments'

export const STUDENT_PAYMENTS = 'STUDENT_PAYMENTS'
export const STUDENT_PAYMENTS_PRINCIPAL = 'STUDENT_PAYMENTS_PRINCIPAL'
export const STUDENT_PAYMENTS_BY_STUDENT = 'STUDENT_PAYMENTS_BY_STUDENT'
export const PAYMENTS_CREATE = 'PAYMENTS_CREATE'

export const ONE_C_CONTRACTS = 'ONE_C_CONTRACTS'
export const ONE_C_CONTRACTS_STUDENT = 'ONE_C_CONTRACTS_STUDENT'
export const ONE_C_SALARY_STAFF = 'ONE_C_SALARY_STAFF'
